// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__ZqxNC","title":"InfoRow_title__3j8wc"};